import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { MatDialog } from '@angular/material/dialog';
import { ApiserviceService } from '../../apiservice.service';
import { NotificationService } from '../services/notification.service';
import { Router } from '@angular/router';
import { ShareService } from '../services/share.service';
import { AppNotificationService } from '../services/app-notification.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { getMessaging, getToken } from "firebase/messaging";
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';

/**
*
* <strong>List of API using</strong>
* <ol>
* <li>umsapi_user_notification_post</li>
* <li>umsapi_user_login_post</li>
* </ol>
*
*/

@Component({
    selector: 'app-admin-login',
    templateUrl: './admin-login.component.html',
    styleUrls: ['./admin-login.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class AdminLoginComponent implements OnInit, OnDestroy {
    hide = true;
    loginForm: FormGroup;
    forgetForm:FormGroup;
    showForgot: boolean = false;
    error: string;
    forget_email: string;
    forget_message = '';
    f_error = false;
    login_action: boolean = false;
    loader: boolean = false;
    isLocalServe = environment.isLocalServe;
    isMobile: boolean;
    private subs = new Subscription();

    get email(): AbstractControl {
        return this.loginForm.get('email');
      }
    get password(): AbstractControl {
    return this.loginForm.get('password');
    }

    get forgotemail(): AbstractControl {
        return this.forgetForm.get('email');
      }

    @ViewChild('tabGroup', {static: true}) tabGroup: MatTabGroup;
    constructor(private readonly _fb: FormBuilder, private readonly api: ApiserviceService, private readonly notify: NotificationService, private readonly recap: ReCaptchaV3Service,
        private readonly router: Router, public dialog: MatDialog, private readonly share: ShareService, private readonly alert: AppNotificationService) {
          this.isMobile = this.api.isMobile;
        if(environment.isLocalServe || this.api.isMobile){
            if (localStorage.getItem('user_id') && localStorage.getItem('city_id')) {
                this.router.navigateByUrl('/admin');
            }
            if (localStorage.getItem('user_id') && !localStorage.getItem('city_id')) {
                this.router.navigateByUrl('/admin/country');
            }
        }else{
            if (!localStorage.getItem('user_id') && !localStorage.getItem('user_token')) {
                let newwindow = window.open(`${environment.adminHost}/login?continue=${environment.baseURL}`, '_self');
                if (window.focus) {newwindow.focus()}
            }else  if (localStorage.getItem('user_id') && localStorage.getItem('city_id')) {
                this.router.navigateByUrl('/admin');
            }
            if (localStorage.getItem('user_id') && !localStorage.getItem('city_id')) {
                this.requestPermission();
                this.router.navigateByUrl('/admin/country');
            }
        }
        this.dialog.closeAll();
    }


    jumpRegister() {
        this.tabGroup.selectedIndex = 1;
    }
    jumpLogin() {
        this.tabGroup.selectedIndex = 0;
    }

    jumpForgot() {
        this.showForgot = !this.showForgot;
    }
    forgetPassword(value) {

        this.forget_message = '';
        let body = {
            "email": value.email,
            "notification_type": "forgot_password"
        }
        this.loader=true;
        const forgetPassSub = this.api.postUmsData('notification', body)
            .subscribe({next:(data: any) => {
                this.loader=false;
                if (data && data.status == 201) {
                    this.f_error = false;
                    this.forget_message = "Reset password link has been sent to your email";
                }
                else {
                    this.f_error = true;
                    this.forget_message = data.message;
                }
            },
                error:err => {
                    this.f_error = true;
                    this.loader=false;
                    this.forget_message = err.error.message;
                }
    });
    this.subs.add(forgetPassSub);
    }
    // forgetPassword() {
    //     this.enable_btn = false;
    //     this.forget_message = '';
    //     let body = "email=" + this.forget_email + "&notification_type=forgot_password";
    //     this.api.postUmsData('user/notification', body)
    //         .subscribe((data: any) => {
    //             this.enable_btn = true;
    //             this.f_error = false;
    //             this.forget_message = "Reset password link has been sent to your email";
    //         },
    //             err => {
    //                 this.f_error = true;
    //                 this.enable_btn = true;
    //                 this.forget_message = "This email id is not register yet."
    //             }
    //         );
    // }

    doLogin(val) {
        const recapSub = this.recap.execute(null).subscribe((token) => {
            this.login(val);
        })
        this.subs.add(recapSub);
    }

    login(val: any) {
        let record: any;
        let name: string;
        this.error = null;
        this.login_action = true;
        let userInfo = {
            "user_name": val.email,
            "user_password": val.password,
            "keep_log_in": false
        }
        const loginSub = this.api.postUmsData('login', userInfo)
            .subscribe({
                next:(res: any) => {
					this.login_action = false;
                    if (res.data && res.status == 200) {
                        record = res.data;
                        this.share.appComp.logIn();
                        localStorage.setItem('user_token', record.token);
                        localStorage.setItem('user_id', record.user_id);
                        localStorage.setItem('session_id', record.session_id);
                        localStorage.setItem('profile_image', record.profile_image);
                        this.api.profile_image.next(record.profile_image)
                        if (this.share.adminComp) this.share.adminComp.profile_image = record.profile_image;
                        if (record.user_details[1].first_name) {
                            name = record.user_details[1].first_name;
                        }
                        if (record.user_details[1].last_name) {
                            name += " " + record.user_details[1].last_name;
                        }
                        localStorage.setItem('user_name', name);
                        let user_info = {
                            "fname": record.user_details[1].first_name,
                            "lname": record.user_details[1].last_name,
                            "contact": record.phone_number,
                            "country": record.nationality,
                            "email": record.primary_email_id,
                            "language": 'en',
                            "imageURL": record.profile_image
                        }

                        localStorage.setItem('user_info', JSON.stringify(user_info));
                        this.api.user_id = record.user_id;
                        this.api.user_name.next(name);
                        this.api.session_id = record.session_id;
                        this.api.user_token = record.token;
                        this.requestPermission();
                        this.router.navigateByUrl('admin/country');
                    } else {
                        this.error = res.message;
                    }
                },
                error:err => {
                    this.login_action = false;
                    this.error = err.error;
                }
    })
    this.subs.add(loginSub);

    }


    // openDialog() {
    //     let dialogRef = this.dialog.open(SelectCity, {
    //         width: '350px',
    //         panelClass: 'create-master-panel',
    //         data: { parent: this }
    //     });
    //     dialogRef.afterClosed().subscribe(result => {
    //        // console.log('The dialog was closed');
    //     });
    // }
    ngOnInit() {
        this.loginForm = this._fb.group({
            email: ['', [Validators.email, Validators.required]],
            password: ['', [Validators.required]]
        });

        this.forgetForm = this._fb.group({
            email: ['', [Validators.email, Validators.required]],
        });
    }

    requestPermission() {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          const messaging = getMessaging();
          getToken(messaging, { vapidKey: environment.firebase.vapidKey })
            .then((currentToken) => {
              if (currentToken) {
                localStorage.setItem("fcm_token", currentToken);
              }
            })
            .catch((err) => {
              console.error("An error occurred while retrieving token. ", err);
            });
        } else {
          this.notify.notify("You’ve blocked notification permissions. Push notifications will be disabled.", "warn");
        }
      });
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
